//import DeskUseDataFunc from "@/pcomponents/common/content/edu/desk/func/desku_func";
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';

class DeskUseDataFunc {
  static get_now_desku_arr(inData: any) {
    let opt_obj = {
      now_ymdhis: "",
      desku_arr: [],
      ...inData
    };
    let now_date_json = DateFunc.get_date_json(new Date(opt_obj.now_ymdhis));
    let now_sec = now_date_json.date_obj.getTime() / 1000;
    let desku_arr = opt_obj["desku_arr"];
    let tmp_now_desku_arr: any = [];
    let desku_arr_len = desku_arr.length;
    for (let i = 0; i < desku_arr_len; i++) {
      let desku_info = desku_arr[i];
      let start_date_str = desku_info["a_date"] + " " + strFunc.HourMinuteToTime(desku_info["a_start_h"], desku_info["a_start_m"]) + ":00";
      let start_date_json = DateFunc.get_date_json(new Date(start_date_str));
      let end_date_str = desku_info["a_date"] + " " + strFunc.HourMinuteToTime(desku_info["a_end_h"], desku_info["a_end_m"]) + ":00";
      if (!strFunc.is_empty(desku_info["a_end_date"])) {
        end_date_str = desku_info["a_end_date"] + " " + strFunc.HourMinuteToTime(desku_info["a_end_h"], desku_info["a_end_m"]) + ":00";
      }
      let end_date_json = DateFunc.get_date_json(new Date(end_date_str));

      let start_sec = start_date_json.date_obj.getTime() / 1000;
      let end_sec = end_date_json.date_obj.getTime() / 1000;
      if (desku_info["a_is_target_time"] == "1" || desku_info["a_is_finish"] == "1") {
        if (start_sec <= now_sec && now_sec < end_sec) {
          tmp_now_desku_arr.push(desku_info);
        }
      } else if (start_sec <= now_sec) {
        tmp_now_desku_arr.push(desku_info);
      }
    }

    return tmp_now_desku_arr;
  };
  static get_desk_use_time_data(inData: any) {
    let opt_obj = {
      now_ymdhis: "",
      desku_info: null,
      ...inData
    };
    if (opt_obj.now_ymdhis == "") {
      opt_obj.now_ymdhis = DateFunc.get_date_format(new Date(), "Y-m-d h:i:s");
    }
    let now_date_json = DateFunc.get_date_json(new Date(opt_obj.now_ymdhis));
    let now_ymd = opt_obj.now_ymdhis.substring(0, 10);
    let now_sec = now_date_json.date_obj.getTime() / 1000;
    let desku_info = opt_obj["desku_info"];
    let per_num = 0;//35
    let remain_minute_num = 0;
    let elapse_minute_num = 0;
    let per_target_num: any = "";// /90
    let time_period = "";//21:00 ~ 22:30
    let percent_num = 0;
    let is_target_time = false;
    let time_data = {
      per_num: per_num,
      remain_minute_num: remain_minute_num,
      elapse_minute_num: elapse_minute_num,
      per_target_num: per_target_num,
      time_period: time_period,
      percent_num: percent_num,
      is_target_time: is_target_time,
      is_finish: false,
    };

    if (strFunc.is_empty(desku_info)) {
      return time_data;
    }
    if (desku_info["a_is_target_time"] == "1") {
      is_target_time = true;
    }

    let start_date_str = desku_info["a_date"] + " " + strFunc.HourMinuteToTime(desku_info["a_start_h"], desku_info["a_start_m"]) + ":00";
    let start_date_json = DateFunc.get_date_json(new Date(start_date_str));
    let end_date_str = desku_info["a_date"] + " " + strFunc.HourMinuteToTime(desku_info["a_end_h"], desku_info["a_end_m"]) + ":00";
    if (!strFunc.is_empty(desku_info["a_end_date"])) {
      end_date_str = desku_info["a_end_date"] + " " + strFunc.HourMinuteToTime(desku_info["a_end_h"], desku_info["a_end_m"]) + ":00";
    }
    let end_date_json = DateFunc.get_date_json(new Date(end_date_str));

    let start_sec = start_date_json.date_obj.getTime() / 1000;
    let end_sec = end_date_json.date_obj.getTime() / 1000;

    let target_time_sec = end_sec - start_sec;

    if (target_time_sec != 0) {
      per_target_num = target_time_sec;
    }

    if (now_sec >= start_sec) {
      per_num = now_sec - start_sec;

      if (per_num > 0) {
        remain_minute_num = Math.round(per_target_num - per_num);
        if (remain_minute_num != 0) {
          remain_minute_num = Math.ceil(remain_minute_num / 60);
        }
      }
    }
    if (now_sec >= end_sec) {
      if (desku_info["a_is_target_time"] == "1" || desku_info["a_is_finish"] == "1") {
        per_num = per_target_num;
        remain_minute_num = 0;
      }
    }
    per_num = Math.round(per_num);

    elapse_minute_num = Math.round(per_num / 60);
    if (elapse_minute_num != 0) {
      elapse_minute_num = Math.ceil(elapse_minute_num);
    }

    if (per_num != 0 && per_target_num != 0) {
      percent_num = (per_num / per_target_num) * 100;
      percent_num = Math.round(strFunc.uncomma(percent_num));
    }
    time_period = strFunc.HourMinuteToTime(desku_info["a_start_h"], desku_info["a_start_m"]);
    if (desku_info["a_is_target_time"] == "1" || desku_info["a_is_finish"] == "1") {
      time_period += " ~ " + strFunc.HourMinuteToTime(desku_info["a_end_h"], desku_info["a_end_m"]);
    } else {
      time_period += " ~ " + strFunc.HourMinuteToTime(now_date_json.h, now_date_json.i);
    }
    let is_finish = false;
    if (desku_info["a_is_target_time"] == "1") {
      if (percent_num >= 100) {
        is_finish = true;
      }
    } else {
      if (desku_info["a_is_finish"] == "1") {
        if (percent_num >= 100) {
          is_finish = true;
        }
      }
    }

    time_data = {
      per_num: per_num,
      remain_minute_num: remain_minute_num,
      elapse_minute_num: elapse_minute_num,
      per_target_num: per_target_num,
      time_period: time_period,
      percent_num: percent_num,
      is_target_time: is_target_time,
      is_finish: is_finish,
    };
    return time_data;
  };
  //좌석사용배열 유저배열에 합치기, 사용중인좌석인지 확인
  static get_user_arr_of_added_desku_arr(inData: any) {
    let opt_obj = {
      info_arr: [],
      desku_arr: [],
      now_ymdhis: "",
      ...inData
    };
    let info_arr = opt_obj.info_arr;
    let desku_arr = opt_obj.desku_arr;
    let now_ymdhis = opt_obj.now_ymdhis;
    let now_date_json = DateFunc.get_date_json(new Date(now_ymdhis));

    //세팅
    for (let i = 0; i < desku_arr.length; i++) {
      let desku_info = desku_arr[i];

      let desk_use_time_data = DeskUseDataFunc.get_desk_use_time_data({
        now_ymdhis: now_ymdhis,
        desku_info: desku_info,
      });
      desku_info["desk_use_time_data"] = desk_use_time_data;

      let desku_h = strFunc.str_pad({ "str": desku_info["a_end_h"], "pad_length": 2 });
      let desku_m = strFunc.str_pad({ "str": desku_info["a_end_m"], "pad_length": 2 });
      let desku_date_str = desku_info["a_end_date"] + " " + desku_h + ":" + desku_m + ":00";
      let desku_date_json = DateFunc.get_date_json(new Date(desku_date_str));

      if (desku_info["a_is_target_time"]) {
        if (now_date_json.date_obj.getTime() < desku_date_json.date_obj.getTime()) {
          desku_info["is_now"] = true;
        }
      } else {
        if (desku_info["a_is_finish"] != "1") {
          desku_info["is_now"] = true;
        }
      }
      desku_arr[i] = desku_info;
    }

    for (let u_i = 0; u_i < info_arr.length; u_i++) {
      let info = info_arr[u_i];
      info["desku_arr"] = [];
      info["desku_info"] = null;
      for (let i = 0; i < desku_arr.length; i++) {
        let desku_info = desku_arr[i];
        if (desku_info["a_user_seq"] == info["a_seq"]) {
          if (desku_info["is_now"]) {
            info["desku_info"] = desku_info;
          }
          info["desku_arr"].push(desku_info);
        }
      }
    }

    return info_arr;
  };
  static get_ordered_stu_arr_by_desku_arr(inData: any) {
    let opt_obj = {
      info_arr: [],
      subject_name: "",
      now_ymdhis: "",
      ...inData
    };

    let info_arr = opt_obj.info_arr;
    let last_desku_arr = [];
    let last_time_sec_arr = [];

    for (let u_i = 0; u_i < info_arr.length; u_i++) {
      let info = info_arr[u_i];
      let last_desku = null;
      if (info["desku_arr"] && info["desku_arr"].length > 0) {
        for (let i = 0; i < info["desku_arr"].length; i++) {
          let desku_info = info["desku_arr"][i];
          let is_able_deku = false;
          if (desku_info["a_date"] == opt_obj["now_ymdhis"].substring(0, 10)) {
            is_able_deku = true;
            if (opt_obj["subject_name"]) {
              if (opt_obj["subject_name"] != desku_info["a_subject"]) {
                is_able_deku = false;
              }
            }
          }
          if (is_able_deku) {
            if (last_desku == null) {
              last_desku = desku_info;
            } else {
              let last_sec = strFunc.timeToSeconds(last_desku["a_start_h"], last_desku["a_start_m"], 0);
              let desku_sec = strFunc.timeToSeconds(desku_info["a_start_h"], desku_info["a_start_m"], 0);
              if (desku_sec > last_sec) {
                last_desku = desku_info;
              }
            }
          }
        }
      }
      if (last_desku != null) {
        last_time_sec_arr.push(strFunc.timeToSeconds(last_desku["a_start_h"], last_desku["a_start_m"], 0));
        last_desku_arr.push(last_desku);
      }
    }

    last_time_sec_arr.sort();
    let last_desku_arr_sec_json: any = {};
    for (let sec_i = 0; sec_i < last_time_sec_arr.length; sec_i++) {
      let row_sec = last_time_sec_arr[sec_i];
      if (last_desku_arr_sec_json[row_sec] == null) {
        last_desku_arr_sec_json[row_sec] = [];
      }
      for (let i = 0; i < last_desku_arr.length; i++) {
        let desku_info = last_desku_arr[i];
        if (strFunc.timeToSeconds(desku_info["a_start_h"], desku_info["a_start_m"], 0) == row_sec) {
          last_desku_arr_sec_json[row_sec].push(desku_info);
        }
      }
    }
    let new_last_desku_arr: any = [];
    for (let key in last_desku_arr_sec_json) {
      let row_desku_info_arr = last_desku_arr_sec_json[key];
      if (row_desku_info_arr.length > 0) {
        new_last_desku_arr = [
          ...new_last_desku_arr,
          ...row_desku_info_arr
        ];
      }
    }
    last_desku_arr = new_last_desku_arr;

    let exist_user_seq_arr: any = [];
    for (let desk_i = 0; desk_i < last_desku_arr.length; desk_i++) {
      let last_desku_info = last_desku_arr[desk_i];
      if (last_desku_info["a_user_seq"]) {
        if (strFunc.str_in_array(last_desku_info["a_user_seq"], exist_user_seq_arr) == -1) {
          exist_user_seq_arr.push(last_desku_info["a_user_seq"]);
        }
      }
    }
    let exist_user_arr: any = [];
    let etc_user_arr: any = [];
    for (let i = 0; i < exist_user_seq_arr.length; i++) {
      for (let u_i = 0; u_i < info_arr.length; u_i++) {
        let info = info_arr[u_i];
        if (info["a_seq"] == exist_user_seq_arr[i]) {
          exist_user_arr.push(info);
          break;
        }
      }
    }
    for (let u_i = 0; u_i < info_arr.length; u_i++) {
      let info = info_arr[u_i];
      if (strFunc.str_in_array(info["a_seq"], exist_user_seq_arr) == -1) {
        etc_user_arr.push(info);
      }
    }

    info_arr = [
      ...exist_user_arr,
      ...etc_user_arr
    ];
    return info_arr;
  };
}
export default DeskUseDataFunc;